module.exports = __webpack_public_path__ + "static/img/global-logo-red@2x.d3e9d03.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/global-logo-red@2x.png
// module id = 712
// module chunks = 0 2 4 5 8 10 11 14 15 16 17 18